import locationService from '../../../../services/notisphere/location'

export default {
    props: {
        supplierOrgId: {type: Number, default: null}
    },
    data() {
        return {
            item: {
                location_id: null,
                idn: null,
                location_name: null,
                notisphere_id: null,
                address1: null,
                address2: null,
                city: null,
                state: null,
                zip_code: null
            },
            formType: 'INSERT',
            labelName: {
                location_id: 'Location Id',
                idn: 'IDN/Hospital Name',
                location_name: 'Location Name',
                notisphere_id: 'Notisphere ID',
                address1: 'Address 1',
                address2: 'Address 2',
                city: 'City',
                state: 'State',
                zip_code: 'Zip'
            },
        }
    },
    computed: {
        form(){
            if(this.formType == 'INSERT'){
                return {
                    title: 'New Location',
                    isDisabled: false
                }
            }
            if(this.formType == 'UPDATE'){
                return {
                    title: 'Update Location',
                    isDisabled: true
                }
            }
        }
    },
    methods: {
        forceRerenderInsert() {
            this.formType = 'INSERT'
            this.$refs.modal.show()
        },
        forceRerenderUpdate(location_id) {
            this.formType = 'UPDATE'
            this.getLocation(location_id)
        },
        async save() {
            var isValid = await this.$refs['observer'].validate()
            if(isValid && this.formType == 'INSERT') {
                this.createLocation()
            }
            if(isValid && this.formType == 'UPDATE'){
                this.updateLocation()
            }
        },
        updateLocation() {
            locationService.sup_updateLocation(this.item, this.supplierOrgId).then(resp =>{
                if (!resp.error){
                    this.$emit('onCompleted', 'UPDATE')
                    this.$refs.modal.hide()
                }
            })
        },
        createLocation() {
            locationService.sup_createLocation(this.item, this.supplierOrgId).then(resp =>{
                if (!resp.error){
                    this.$emit('onCompleted', 'INSERT')
                    this.$refs.modal.hide()
                }
            })
        },
        getLocation(location_id) {
            locationService.sup_getLocation(location_id, this.supplierOrgId).then(resp =>{
                if (!resp.error){
                    this.item = resp.data.d
                    this.$nextTick(()=>{
                        this.$refs.modal.show()
                    })
                }
            })
        }
    }
}